import { Injectable } from '@angular/core';
import { gql, Mutation } from 'apollo-angular';

import { QUOTE_PRICING_FRAGMENT } from 'graphql/fragments/quote-pricing';
import { QUOTE_PRICING_STATE_FRAGMENT } from 'graphql/fragments/quote-pricing-state';
import { Mutation as RootMutation } from 'graphql/models/generated';

export const DELETE_POSITIONS_MUTATION = gql`
  mutation deleteLines(
    $documentVersion: DocumentVersionInput!,
    $lineIds: [String!]!,
    $withPricing: Boolean = true
  ) {
    quotes {
      modify(documentVersion: $documentVersion) {
        deleteLines(lineIds: $lineIds) {
          deletedLines
          quote {
            documentId
            revision
            status
            snkModifier {
              profile {
                firstName
                lastName
              }
            }
            ...QuotePricingFragment @include(if: $withPricing)
            ...QuotePricingStateFragment @skip(if: $withPricing)
          }
        }
      }
    }
  }
  ${QUOTE_PRICING_FRAGMENT}
  ${QUOTE_PRICING_STATE_FRAGMENT}
`;

@Injectable({
  providedIn: 'root'
})
export class DeletePositionsMutation extends Mutation<RootMutation> {
  document = DELETE_POSITIONS_MUTATION;
}
